import {Box} from '@mui/material';
import React, {ReactNode} from 'react';
import {sx} from './sx'

interface IProps {
    children: ReactNode
}

const ContentLayoutSingleVoyage = ({children}: IProps) => {
    return (
        <Box sx={sx.root}>
            {children}
        </Box>
    );
};

export default ContentLayoutSingleVoyage;